<template>
  <div ref="modal"
       class="modal fade" id="delModal" tabindex="-1" role="dialog"
       aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content border-0">
        <div class="modal-header bg-danger text-white">
          <h5 class="modal-title">
            <span>刪除 {{temp.title}}</span>
          </h5>
          <button type="button" class="btn-close"
                  data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          是否刪除
          <strong class="text-danger">{{ temp.title }}</strong> (刪除後將無法恢復)。
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary"
                  data-bs-dismiss="modal">取消
          </button>
          <button @click="$emit('emit-delitem',temp)"
                  type="button" class="btn btn-danger">確認刪除
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Modal from 'bootstrap/js/dist/modal'
import modalMixin from '../mixins/modalMixin'

export default {
  props: {
    nowData: {
      type: Object,
      default () { return {} }
    }
  },
  watch: {
    nowData () {
      this.temp = this.nowData
    }
  },
  data () {
    return {
      modal: {},
      temp: {}
    }
  },
  // methods: {
  //   openModal () {
  //     this.modal.show()
  //   },
  //   closeModal () {
  //     this.modal.hide()
  //   }
  // },
  // mounted () {
  //   this.modal = new Modal(this.$refs.modal)
  // },
  mixins: [modalMixin]
}
</script>
